import { Action, createReducer, on } from '@ngrx/store';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

import * as timingRulesActions from './timing-rules.actions';
import { Trigger } from 'src/app/models/trigger';

export interface TimingRulesState extends EntityState<Trigger> {
  savedTriggers: Trigger[];
}

export const timingRulesAdapter: EntityAdapter<Trigger> = createEntityAdapter<Trigger>({});

export const initialTimingRulesState: TimingRulesState = timingRulesAdapter.getInitialState({
  savedTriggers: null,
});

export const reducer = createReducer(
  initialTimingRulesState,
  on(timingRulesActions.saveTimingRulesSuccess, (state, { savedTriggers }) => {
    return {
      ...state,
      savedTriggers,
    };
  })
);

export function TimingRulesReducer(state: TimingRulesState | undefined, action: Action) {
  return reducer(state, action);
}

export const { selectIds, selectEntities, selectAll, selectTotal } = timingRulesAdapter.getSelectors();
